'use strict';

class ReporteEmpController {
  constructor($filter, $location, Datetime, DataService, Storage, Loading) {
    'ngInject';

    this.$filter =  $filter;
    this.Datetime = Datetime;
    this.DataService = DataService;
    this.Storage = Storage;
    this.Loading = Loading;

    // Verificar si tiene acceso al menu.
    let menu = Storage.get('menu');
    menu = $filter('filter')(menu, {'label':'REPORTES'});
    if(menu[0]) {
      menu = $filter('filter')(menu[0].submenu, {'url':'descargacsv'});
    }
    if(!menu[0]) {
      $location.path('/bandeja');
    }
    this.rol = Storage.get('rol');
  }

  $onInit() {
    this.fecha = new Date();
    this.dt1 = {
      opened: false,
      options: {
        maxDate: new Date(),
        minDate: new Date(1979, 0, 1),
        startingDay: 1,
        showWeeks: false
      }
    };
    // this.dt1.options.maxDate.setDate(this.dt1.options.maxDate.getDate()-1);
    this.dt2 = {
      opened: false,
      options: {
        maxDate: new Date(),
        minDate: new Date(1979,0,1),
        startingDay: 1,
        showWeeks: false
      }
    };

    this.promueves = [
      { valor: 'PROMUEVE', texto: 'PROMUEVE' },
      { valor: 'SHB', texto: 'SELLO HECHO EN BOLIVIA'},
    ];
    this.ambito = this.promueves[0];
  }

  // Abrir datepicker
  dt1Open() {
    this.dt1.opened = true;
  }
  dt1Change() {
    this.dt2.options.minDate = new Date(this.dt1.value);
    // this.dt2.options.minDate.setDate(this.dt2.options.minDate.getDate()+1);
  }
  dt2Open() {
    this.dt2.opened = true;
  }
  dt2Change() {
    this.dt1.options.maxDate = new Date(this.dt2.value);
    // this.dt1.options.maxDate.setDate(this.dt1.options.maxDate.getDate()-1);
  }

  descargarCsv(form) {
    form.$setDirty();
    if(form.$error && form.$error.required) {
      for(let i in form.$error.required) {
        if(form.$error.required[i].$setTouched) {
          form.$error.required[i].$setTouched();
        }
      }
    }
    if(this.dt1.value && this.dt2.value) {
      let url = this.rol==2? 'reporteprobolivia':'reportepromueve';
      let datos = {};
      datos.desde = this.$filter('date')(this.dt1.value,'dd/MM/yyyy');
      datos.hasta = this.$filter('date')(this.dt2.value,'dd/MM/yyyy');
      if(this.rol==3) {
        datos.ambito = this.ambito.valor;
      }
      datos.incluyeMigrados = this.incluyeMigrados;
      this.Loading.show('Generando archivo', true);
      this.DataService.file(url,'text/csv',datos).then((resp)=>{
        let a = document.createElement('a');
        a.href = resp;
        a.download = this.rol==2?'probolivia':'promueve';
        if(datos.ambito=='SHB') {
          a.download+='_shb';
        }
        a.download+= '_'+this.$filter('date')(this.fecha,'yyyyMMddhhmmss')+'.csv';
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        this.Loading.hide();
        angular.element(a).remove();
      });
    }
  }

  /**
   * isMayor - verificar si la fecha1 es mayor a la fecha2
   *
   * @param  {string} val1 fecha1
   * @param  {string} val2 fecha2
   * @return {boolean}     true si falta un parametro
   */
  isMayorIgual(val1, val2) {
    if(!val1 || !val2) {
      return true;
    }
    let f1 = this.Datetime.isValid(val1)? val1: this.$$toDate(val1,'/');
    let f2 = this.Datetime.isValid(val2)? val2: this.$$toDate(val2,'/');
    return f1>=f2;
  }
  $$toDate(date, separator) {
      date = date.split(separator || '-');
      return new Date(date[2],date[1]-1,date[0]);
  }

}

export default ReporteEmpController;



// WEBPACK FOOTER //
// ./src/app/components/reportecsv/reporte.emp.controller.js